import { useState, useEffect } from "react";

const useOS = () => {
  const [os, setOS] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/windows/.test(userAgent)) {
      setOS("Windows");
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setOS("iOS");
    } else if (/android/.test(userAgent)) {
      setOS("Android");
    } else if (/macintosh/.test(userAgent)) {
      setOS("Mac OS");
    } else {
      setOS("Unknown");
    }
  }, []);

  return os;
};

export default useOS;
